// Text align
export const CENTER = "Center";
export const LEFT = "Left";
export const RIGHT = "Right";

// Attribut variant
export const ICON = "Icon";
export const TEXT = "Text";
export const BOTH = "Both";
export const NONE = "None";

// Date variant
export const DATE = "Date";
export const TIME = "Time";
export const DATETIME = "DateTime";
export const MONTH = "Month";
export const YEAR = "Year";

// Round direction
export const UP = "Up";
export const DOWN = "Down";

// Order
export const ASC = "asc";
export const DESC = "desc";

// font weight --- bude pridano do nastaveni prezentacniho modelu
export const NORMAL = "NORMAL";
export const BOLD = "BOLD";
